import { render, staticRenderFns } from "./EmailUpsell.vue?vue&type=template&id=e8fa79bc&"
import script from "./EmailUpsell.vue?vue&type=script&lang=js&"
export * from "./EmailUpsell.vue?vue&type=script&lang=js&"
import style0 from "./EmailUpsell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports